<template>
  <v-layout fill-height column>
    <div class="question" v-html="ques[0]"></div>
    <div class="answer">
      <div v-for="n in replyArr.length" :key="n" class="d-flex justify-space-between align-center mb-4">
        <div class="pos-relative" style="width: calc(100% - 50px)">
          <v-slider
              v-model="value[n-1]"
              hide-details
              color="orange darken-3"
              track-fill-color="#E9E6FF"
              thumb-color="transparent"
              class="slider"
              :readonly="cmplt"
          ></v-slider>
          <div class="textarea-input">
            {{ replyArr[n - 1] }}
          </div>
        </div>
        <div class="fs-14 fw-700 text-right primary--text" style="width: 50px">
          {{ value[n - 1] }}%
        </div>
      </div>
      <div v-if="rtoType == '01'" class="fs-24 fw-700 text-center primary--text py-4">
        {{ totalVal }}%
      </div>
    </div>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total" :disabledNext="disabledNext" />
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"
import store from '../../../store'

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    value: [],
    totalVal: 0,
    rtoType: "",
    disabledNext: false,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyObjArr: [],
    userReplyNo: [],
    userReply: [],
  }),
  components: {
    FooterBtnsNext,
  },
  watch: {
    value() {
      this.totalValue()
    },
    current() {
      // alert(this.current)
      // 동일 타입 재 조회시 초기화
      this.value = [],
          this.totalVal = 0,
          this.rtoType = "",
          this.disabledNext = false,
          this.free = 'N',
          this.cmplt = false,
          this.ques = [],
          this.replyArr = [],
          this.replyObjArr = [],
          this.userReplyNo = [],
          this.userReply = [],
          this.getUnitDetailUse()
    }
  },
  created() {
    this.getUnitDetailUse()
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true
      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
          .then(res => {
            if (res.success) {

              // 질문 리스트
              res.data.unitDtlQuesList.forEach((quesEl) => {

                // 질문 셋팅
                // this.ques[i] = quesEl.ques
                this.ques.push(quesEl.ques)
                this.rtoType = quesEl.rtoType

                // 답변 셋팅
                quesEl.unitDtlReplyList.forEach((replyEl) => {
                  // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                  this.replyArr.push(replyEl.reply)
                  this.replyObjArr.push(replyEl)
                  this.userReplyNo.push(0)
                });

                // 유저 답변 셋팅
                if (quesEl.memberUnitDtlReplyList.length > 0) {

                  // 답변초기화
                  this.replyArr.splice(0, this.replyArr.length);
                  this.replyObjArr.splice(0, this.replyObjArr.length);

                  quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                    this.userReplyNo[j] = userReplyEl.memberUnitDtlReplyUseNo
                    this.replyArr.push(userReplyEl.reply)
                    this.replyObjArr.push(userReplyEl)
                    this.value[j] = userReplyEl.score
                  });
                  this.totalValue()
                }
              });

            } else {
              console.log(res.msg)
              // this.answer = [];
            }
          })
          .catch(error => {
            console.error(error)
            // this.answer = [];
          })
          .finally(() => {
          })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅
        this.replyObjArr.forEach((replyObj, i) => {
          this.userReply[i] = {
            unitId: replyObj.unitId,
            sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

            memberUnitDtlReplyUseNo: this.userReplyNo[i],
            // unitUseNo: replyObj.unitUseNo,
            unitNo: replyObj.unitNo,
            // unitDtlUseNo: replyObj.unitDtlUseNo,
            unitDtlNo: replyObj.unitDtlNo,
            // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
            unitDtlQuesNo: replyObj.unitDtlQuesNo,
            // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
            unitDtlReplyNo: replyObj.unitDtlReplyNo,
            userKey: this.$store.state.auth.authUser.userKey,
            reply: replyObj.reply,
            score: this.value[i],
            freeYn: this.free
          }

        })
        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
            .then(res => {
              if (res.success) {
                setTimeout(() => this.$emit('next'), 500); // 저장한 이후
              } else {
                console.log(res.msg)
              }
            })
            .catch(error => {
              console.error(error)
            })
            .finally(() => {
            })
      } else {
        this.$emit('next')
      }
    },
    totalValue() {
      this.totalVal = 0
      this.value.forEach((val) => {
        this.totalVal = this.totalVal + val
      })
      this.totalVal = Math.round(this.totalVal / this.value.length)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep.slider {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;

  .v-input__control, .v-input__slot, .v-slider, .v-slider__track-container {
    height: 100% !important;
  }

  .v-slider {
    margin: 0;
  }

  .v-slider__track-container {
    height: 100%;
    border-radius: 6px;
    overflow: hidden;

    .v-slider__track-background {
      background-color: transparent !important;
      background: transparent !important;
    }
  }

  .v-slider__thumb {
    display: none;
  }
}

.textarea-input {
  position: relative;
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 6px;
  min-height: 70px;
  padding: 10px 18px;
  z-index: 2;
  pointer-events: none;
}
</style>
